export default "__VITE_ASSET__a9e3ff8c__"